import { QueryParams, QueryResult } from "common";

export const FacilitiesActiveLabel = new Map<boolean, string>([
  [true, "Active"],
  [false, "Inactive"],
]);

export const FacilitiesActiveLabelValues = [
  { label: "Active", value: true },
  { label: "Inactive", value: false }
];

// NACHA Standard Entry Class codes
export enum SecCode {
  PPD = "ppd",
  CCD = "ccd",
  ACK = "ack",
  ADV = "adv",
  ARC = "arc",
  ATX = "atx",
  BOC = "boc",
  CIE = "cie",
  COR = "cor",
  CTX = "ctx",
  DNE = "dne",
  ENR = "enr",
  IAT = "iat",
  MTE = "mte",
  POP = "pop",
  POS = "pos",
  RCK = "rck",
  SHR = "shr",
  TEL = "tel",
  TRC = "trc",
  TRX = "trx",
  WEB = "web",
  XCK = "xck",
}

export const SecCodeLabel = new Map<SecCode, string>([
  [SecCode.PPD, "PPD - Prearranged Payment and Deposit"],
  [SecCode.CCD, "CCD - Corporate Credit or Debit"],
  [SecCode.ACK, "ACK - ACH Payment Acknowledgment"],
  [SecCode.ADV, "ADV - Automated Accounting Advice"],
  [SecCode.ARC, "ARC - Accounts Receivable Entry"],
  [SecCode.ATX, "ATX - Financial EDI Acknowledgment"],
  [SecCode.BOC, "BOC - Back Office Conversion"],
  [SecCode.CIE, "CIE - Customer Initiated Entry"],
  [SecCode.COR, "COR - Notification of Change"],
  [SecCode.CTX, "CTX - Corporate Trade Exchange"],
  [SecCode.DNE, "DNE - Death Notification Entry"],
  [SecCode.ENR, "ENR - Automated Enrollment Entry"],
  [SecCode.IAT, "IAT - International ACH Transaction"],
  [SecCode.MTE, "MTE - Machine Transfer Entry"],
  [SecCode.POP, "POP - Point of Purchase"],
  [SecCode.POS, "POS - Point of Sale"],
  [SecCode.RCK, "RCK - Re-presented Check"],
  [SecCode.SHR, "SHR - Shared Network Transaction"],
  [SecCode.TEL, "TEL - Telephone-Initiated Entry"],
  [SecCode.TRC, "TRC - Truncated Entry"],
  [SecCode.TRX, "TRX - Truncated Entries Exchange"],
  [SecCode.WEB, "WEB - Internet-Initiated/Mobile Entry"],
  [SecCode.XCK, "XCK - Destroyed Check Entry"],
]);

export const FacilitiesIsDefaultLabel = new Map<boolean, string>([
  [true, "Yes"],
  [false, "No"],
]);

export const FacilitiesIsDefaultLabelValues = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];

export interface FacilityInfoData {
  id?: number;
  name?: string;
  isDefault?: boolean;
  seniorLenders?: string[];
  mezzanineLenders?: string[];
}

export interface FacilityListData {
  id: number;
  active?: boolean;
  name?: string;
  isDefault?: boolean;
  maximumAcceptableLoanCreditLimit?: number;
  borrowingCapacity?: number;
  inboundBankAccount?: BankAccountData;
  outboundBankAccount?: BankAccountData;
  allowedProducts?: string[];
}

export interface FacilityDetailsData {
  id: number;
  active?: boolean;
  name?: string;
  isDefault?: boolean;
  maximumAcceptableLoanCreditLimit?: number;
  borrowingCapacity?: number;
  inboundBankAccount?: BankAccountData;
  outboundBankAccount?: BankAccountData;
  allowedProducts?: string[];
  seniorLenders?: LendersData;
  mezzanineLenders?: LendersData
}

export interface CreateFacilityData {
  active?: boolean;
  name?: string;
  isDefault?: boolean;
  maximumAcceptableLoanCreditLimit?: number;
  borrowingCapacity?: number;
  inboundBankAccount?: BankAccountData;
  outboundBankAccount?: BankAccountData;
  allowedProducts?: string[];
  seniorLenders?: LendersData;
  mezzanineLenders?: LendersData
}

export interface FacilityEditData extends CreateFacilityData {
  id?: number;
}

export interface BankAccountData {
  bankName?: string;
  routingNumber?: string;
  accountNumber?: string;
  bankNachaLocation?: string;
  companyAchCode?: string;
  secCode?: SecCode;
  companyEntryDescription?: string;
  nachaDestinationName?: string;
}

export interface LendersData {
  percentage?: number;
  lendersNames?: string[];
} 

export interface FacilityListInputData {
  dataSource: FacilityQueryResult;
  isWriteAllowed: boolean;
  filterData: QueryParams;
}

export interface FacilityQueryResult
  extends QueryResult<FacilityListData> {}

export interface FacilityInputData {
  dataSource: FacilityDetailsData | undefined;
  isWriteAllowed: boolean;
  isCreating: boolean;
}

export class FacilityQueryParams extends QueryParams {
    isDefault?: boolean;
    name?: string;
    productCode?: string;

    constructor(params?: any) {
      super(params)
      params = params || {};

      this.isDefault = params.isDefault || undefined;
      this.active = params.active || undefined;
      this.name = params.name || undefined;
      this.productCode = params.productCode || undefined;
  }
}
